import PropTypes from "prop-types";
import { Button, Col, Row } from "reactstrap";
import BotonAsignarTurno from "./boton-asignar-turno";
import BotonExportarCuadroTurnos from "./boton-exportar-cuadro-turnos";
import BotonGenerarCuadroTurnos from "./boton-generar-cuadro-turnos";
import SedesConvenciones from "./SedesConvenciones/sedes-convenciones";


import CuadroTurnosContext from "../../../store/cuadro-turnos-context";
import { useContext  } from "react";
import BotonEliminarCuadroTurnos from "./boton-eliminar-cuadro-turnos";
import BotonAsignarActividades from "./boton-asignar-actividades";
import BotonEditarTurno from "./boton-editar-turno";
import FiltrosCuadrosTurnos from "./FiltrosCuadrosTurnos/filtros-cuadros-turnos";
import BotonImprimirCuadroTurno from "./boton-imprimir-cuadro-turno";
import ModalTutorial from "./modal-tutorial";
import useModal from "../../../../../core/hooks/use-modal";
import { useEffect } from "react";

export default function CabeceraCuadrosTurnos({ modalConvenciones }) {
    const {
        getCuadroTurnos,
        filtros,
    } = useContext(CuadroTurnosContext);

    const modalTutorial = useModal();
    const onTurnoAsignado = () => getCuadroTurnos();
    const abrirModalConvenciones = () => modalConvenciones.open();

    useEffect(() => {
        const haVistoElTutorial = window.localStorage.getItem('whats-new-v2.0.0');

        if(haVistoElTutorial == null){
            modalTutorial.open();
            window.localStorage.setItem('whats-new-v2.0.0', 'true');
        }
    }, []);

    return (
        <>
            <Row>
                <Col lg={8} md={8} sm={12}>
                    <BotonAsignarTurno className="m-1" onTurnoAsignado={onTurnoAsignado} />

                    <BotonEditarTurno className="m-1" onTurnoAsignado={onTurnoAsignado} />

                    <BotonAsignarActividades
                        className="m-1"
                        onActividadAsignada={onTurnoAsignado}
                    />

                    <BotonGenerarCuadroTurnos
                        className="m-1"
                        sedeAreaLider={filtros.sedeAreaLider}
                        onGenerarCuadroTurnos={() => getCuadroTurnos()}
                    />
                    <BotonEliminarCuadroTurnos
                        className="m-1"
                        sedeAreaLider={filtros.sedeAreaLider}
                        onEliminarCuadroTurnos={() => getCuadroTurnos()}
                    />
                    <BotonExportarCuadroTurnos
                        className="m-1"
                        filtros={filtros}
                    />
                    <BotonImprimirCuadroTurno />
                    <Button
                        title="Ver convenciones"
                        color="bg-grey"
                        className="m-1 btn-salmon"
                        onClick={abrirModalConvenciones}
                    >
                        <i className="fas fa-sort-alpha-up"></i>
                    </Button>
                    <Button
                        title="Ver tutorial"
                        color="secondary"
                        className="m-1"
                        onClick={() => modalTutorial.open()}
                    >
                        <i className="fab fa-leanpub"></i>
                    </Button>
                </Col>
                <Col md={4} lg={4} className="py-sm-3 py-3 py-md-1 py-lg-1">
                    <SedesConvenciones />
                </Col>
            </Row>

            <FiltrosCuadrosTurnos />
            <ModalTutorial modalState={modalTutorial}/>
        </>
    );
}

CabeceraCuadrosTurnos.propTypes = {
    modalConvenciones: PropTypes.object,
};
